import { render } from "./Festivals.vue?vue&type=template&id=3fcfa498&scoped=true"
import script from "./Festivals.vue?vue&type=script&lang=js"
export * from "./Festivals.vue?vue&type=script&lang=js"

import "./Festivals.vue?vue&type=style&index=0&id=3fcfa498&lang=scss&scoped=true"

import exportComponent from "/var/www/html/punchline-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fcfa498"]])

export default __exports__